module.exports = __webpack_public_path__ + "static/media/ch.12ad982c.svg";